import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import TestFields from '@jumbo/Dashboards/Tests/TestFields';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.testsPage'} />, link: '/tests' },
  { label: <IntlMessages id={'pages.editTestPage'} />, isActive: true },
];

const EditTest = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.editTestPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <TestFields />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default EditTest;
